import { Component, Inject, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-pricing-contact',
	templateUrl: './pricing-contact.component.html',
	styleUrls: ['./pricing-contact.component.scss'],
})
export class PricingContactComponent implements OnInit {
	public contactForm: FormGroup;

	constructor(private readonly _fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,) {
		this.contactForm = this._fb.group({
			id: new FormControl(null),
			name: new FormControl('', [Validators.required]),
		});
	}

	ngOnInit(): void {}

	public onSendForm() {}
}
